import styled from 'styled-components';

export const AsterIconStyled = styled.div`
  .asterIconWrapper {
    display: inline-flex;
    padding: 0px 4px 0px 2px;
    justify-content: center;
    margin-top: 90px;
    align-items: center;
    gap: 4.021px;
    border-radius: 4px;
    background: ${(props) => props?.theme?.blue?.lightblue};
    position: absolute;
    z-index: 1;
    height:27px;
  }

  .asterIconFacility {
    display: inline-flex;
    padding: 4px;
    justify-content: center;
    align-items: center;
    gap: 1.021px;
    border-radius: 7px 0px 4px 0px;
    background: ${(props) => props?.theme?.blue?.lightblue};
    position: relative;
    z-index: 1;
    margin-top: 0px;
    height:30px;
  }
`;

export default AsterIconStyled;